import React, { FC, MouseEvent } from 'react';
import { useRouter } from 'next/router';
import styled from '@emotion/styled';
import { Hyperlink } from '../elements/Typography/Link/Hyperlink';

interface IBackButtonProps {
  label: string;
  onClick?: ((event: MouseEvent) => void) | false;
}

export const BackButton: FC<IBackButtonProps> = ({
  label,
  onClick,
}) => {
  const router = useRouter();
  let onClickEvent:  ((event: MouseEvent) => void) | undefined = onClick ? onClick : (event: MouseEvent): void => {
    event.preventDefault();

    if(window.history.length === 1){
      router.push('/baumaschinen-mieten');
      return;
    }

    router.back();
  };

  if (false === onClick) {
    onClickEvent = undefined;
  }

  return (
    <HyperLinkWrapper href={'#'} onClick={onClickEvent}>
      <Hyperlink iconLeft='link-arrow'>{label}</Hyperlink>
    </HyperLinkWrapper>
  );
};

const HyperLinkWrapper = styled.a`
  .icon {
    svg {
      transform: rotate(180deg);
    }
  }

  @media print {
    display: none;
  }
`;
